import { ISiteDeployment } from "@stores"

// Runtime configuration - $TEMPLATE
const config:Partial<ISiteDeployment> = {
  _id:                    '$DEPLOYMENT',
  apiGatewayEndpoint:     '$DESIGN_BOARD_API_GATEWAY_ENDPOINT',
  wsApiGatewayEndpoint:   '$DESIGN_BOARD_API_GATEWAY_WS_ENDPOINT',
  graphqlEndpoint:        '$DESIGN_BOARD_GRAPHQL_ENDPOINT',
  mediaUrl:               '$MEDIA_MICROSERVICE_ENDPOINT',
  centricURL:             '$CENTRIC_URL',
  plmC8URL:               '$PLM_C8_URL',
  esUrl:                  '$ES_URL',
  esApiKey:               '$ES_CLIENT_API_KEY' || '$ES_API_KEY',
  servicesUrl:            '$SERVICES_URL',
  secondaryServicesUrl:   '$SECONDARY_SERVICE_URL',
  leToken:                '$LE_TOKEN',
  imgProxyUrl:            '$IMAGE_PROXY_URL',
  loginPageBgImage:       '$LOGIN_PAGE_BG_IMAGE',
}

export default config



// WEBPACK FOOTER //
// ./src/config/index.ts